// ============================================================================
// i18nRoutes — mapeamento de idioma ↔ URL das páginas PÚBLICAS (SEO multilíngue).
// ----------------------------------------------------------------------------
// Cada idioma tem sua própria URL para o Google indexar por mercado:
//   PT (padrão) → sem prefixo  (/, /register, /login, /terms-of-use)
//   ES          → prefixo /es  (/es, /es/register, …)
//   EN          → prefixo /en  (/en, /es/register, …)
// A URL é AUTORITATIVA nas páginas públicas (define o idioma). O componente Seo
// gera o canonical e os hreflang a partir daqui; o LanguageSync força o idioma
// pela URL; e o LanguageSelector troca a URL ao trocar de idioma.
// ============================================================================

import { LANDING_PATHS } from "./landingContent";

export const LANGS = ["pt", "es", "en"];
export const DEFAULT_LANG = "pt";

// Prefixo de URL do idioma (PT é a raiz, sem prefixo).
export const langPrefix = (lang) => (lang === "es" ? "/es" : lang === "en" ? "/en" : "");

// Caminhos públicos (base, SEM prefixo de idioma) — inclui as landing pages.
export const PUBLIC_PATHS = ["/", "/register", "/login", "/terms-of-use", ...LANDING_PATHS];
export const isPublicPath = (basePath) => PUBLIC_PATHS.includes(basePath);

// Extrai { lang, basePath } de um pathname. "/es/register" → { es, "/register" }.
export const parseLangPath = (pathname) => {
  const p = pathname || "/";
  if (p === "/es" || p.startsWith("/es/")) return { lang: "es", basePath: p.slice(3) || "/" };
  if (p === "/en" || p.startsWith("/en/")) return { lang: "en", basePath: p.slice(3) || "/" };
  return { lang: "pt", basePath: p };
};

// Monta o caminho de um idioma para um basePath. (es, "/") → "/es"; (pt, "/") → "/".
export const pathFor = (lang, basePath) => {
  const prefix = langPrefix(lang);
  if (basePath === "/") return prefix || "/";
  return `${prefix}${basePath}`;
};
